/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { FC } from 'react';
import { AlertDialog } from '@components/design-system';
import * as Styles from '@components/modals/styles';
import { auctionWithdraw } from '@lib/beacon';

export interface IAuctionAcceptCurrentBid {
  open?: boolean;
  onOpenChange?: (value: boolean) => void;
  auctionId?: number;
}

export const AuctionAcceptCurrentBid: FC<IAuctionAcceptCurrentBid> = ({ open, onOpenChange, auctionId }) => {
  const handleConfirm = () => {
    auctionWithdraw(auctionId!);

    if (onOpenChange) {
      onOpenChange(false);
    }
  };

  const handleCancel = () => {
    if (onOpenChange) {
      onOpenChange(false);
    }
  };

  return (
    <AlertDialog
      title="Accept Current Bid"
      description="You are about to accept the current bid, if you confirm the auction will finish ahead of time."
      open={open}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
    >
      <Styles.Content />
    </AlertDialog>
  );
};
